export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/system_thinking_vs_design_thinking-712500d93e41e193e171dcd87a6cd725.png";